(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  // Previous playful-mode preferences do not apply to the new brand direction.
  document.documentElement.removeAttribute('data-motion');
  const progress = document.createElement('div');
  progress.className = 'ts-progress'; progress.setAttribute('aria-hidden', 'true');
  document.body.append(progress);
  let scheduled = false;
  function update() { const total = document.documentElement.scrollHeight - innerHeight; progress.style.transform = `scaleX(${total > 0 ? Math.min(1, Math.max(0, scrollY / total)) : 0})`; scheduled = false; }
  addEventListener('scroll', () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }, { passive: true });
  addEventListener('resize', update, { passive: true }); update();
  const menu = document.querySelector('.at-mobile-menu');
  menu?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary')?.focus(); } });
  if (!reduced.matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(e => { if (e.isIntersecting) { e.target.dataset.reveal = 'visible'; observer.unobserve(e.target); } }), { threshold: 0.08 });
    document.querySelectorAll('.ts-manifesto, .ts-collection > div').forEach(el => { el.dataset.reveal = 'pending'; observer.observe(el); });
    reduced.addEventListener('change', e => { if (e.matches) { observer.disconnect(); document.querySelectorAll('[data-reveal]').forEach(el => { el.dataset.reveal = 'visible'; }); } });
  }
})();

// Subtle cat-and-dog tracks for the Blue & Gold storefront.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(any-pointer: fine)');
  const canvas = document.createElement('canvas');
  canvas.className = 'ts-paw-trail';
  canvas.setAttribute('aria-hidden', 'true');
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  document.body.append(canvas);
  let tracks = [], previous = null, stride = 0, frame = 0;
  const lifetime = 1250;
  function clear() {
    tracks = []; previous = null;
    cancelAnimationFrame(frame); frame = 0;
    ctx.clearRect(0, 0, innerWidth, innerHeight);
  }
  function resize() {
    clear();
    const ratio = Math.min(devicePixelRatio || 1, 1.5);
    canvas.width = Math.round(innerWidth * ratio);
    canvas.height = Math.round(innerHeight * ratio);
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
  }
  function ellipse(x, y, rx, ry, angle = 0) {
    ctx.beginPath(); ctx.ellipse(x, y, rx, ry, angle, 0, Math.PI * 2); ctx.fill(); if(ctx.lineWidth)ctx.stroke();
  }
  function draw(now) {
    frame = 0;
    ctx.clearRect(0, 0, innerWidth, innerHeight);
    tracks = tracks.filter(track => now - track.born < lifetime);
    for (const track of tracks) {
      ctx.save(); ctx.translate(track.x, track.y); ctx.rotate(track.angle);
      ctx.fillStyle = track.color;
      ctx.strokeStyle = track.light ? '#09294d' : '#fff8df'; ctx.lineWidth = .65;
      ctx.globalAlpha = (track.light ? .80 : .52) * Math.pow(1 - (now - track.born) / lifetime, 1.5);
      const scale = track.dog ? 1.2 : 1.03;
      ctx.scale(scale, scale);
      ellipse(0, 3.5, 5.1, track.dog ? 5 : 4.1);
      for (const [x, y] of [[-5.9, -2], [-2.2, -5.1], [2.2, -5.1], [5.9, -2]]) {
        ellipse(x, y, 2.1, track.dog ? 3 : 2.35, x * 0.055);
      }
      ctx.restore();
    }
    if (tracks.length) frame = requestAnimationFrame(draw);
  }
  document.addEventListener('pointermove', event => {
    if (reduced.matches || !fine.matches || event.pointerType !== 'mouse') return;
    if (!(event.target instanceof Element) || event.target.closest('input, textarea, select, button, summary, [contenteditable], dialog')) {
      previous = null; return;
    }
    const point = { x: event.clientX, y: event.clientY };
    if (!previous) { previous = point; return; }
    const dx = point.x - previous.x, dy = point.y - previous.y;
    if (Math.hypot(dx, dy) < 42) return;
    const angle = Math.atan2(dy, dx) + Math.PI / 2;
    const side = stride++ % 2 ? 7 : -7;
    const element = event.target;
    const imageRegion=element.matches('img')||element.closest('.sc-home-card,.lx-hero,.lx-companions,.ts-campaign,.lp-gallery,.sc-product-image,.lc-image');
    let dark=!!imageRegion||!!element.closest('[data-paw-tone=light],.ts-hero,.ts-collection,.at-footer');
    if(!dark){for(let n=element;n&&n!==document.body;n=n.parentElement){const rgb=getComputedStyle(n).backgroundColor.match(/[\d.]+/g);if(rgb&&rgb.length>=3&&(rgb.length<4||Number(rgb[3])>.5)){dark=(.2126*rgb[0]+.7152*rgb[1]+.0722*rgb[2])<125;break;}}}
    tracks.push({ x: point.x + Math.cos(angle) * side, y: point.y + Math.sin(angle) * side,
      angle, born: performance.now(), dog: Math.floor(stride / 4) % 2 === 1,
      light: dark, color: dark ? '#FFE6A1' : '#073B87' });
    if (tracks.length > 20) tracks.shift();
    previous = point;
    if (!frame) frame = requestAnimationFrame(draw);
  }, { passive: true });
  addEventListener('scroll', clear, { passive: true });
  addEventListener('resize', resize, { passive: true });
  document.addEventListener('pointerout', event => { if (!event.relatedTarget) clear(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) clear(); });
  reduced.addEventListener('change', clear);
  fine.addEventListener('change', clear);
  addEventListener('pagehide', clear);
  resize();
})();
